import {PUBLIC_ENV_KEY} from "@/env";

export type ClientConfigType = {
    applicationInsightsConnectionString: string;
    blackMirrorApiUrl: string;
}


export function getClientConfig(): ClientConfigType {
    if (typeof window === 'undefined') {
        throw new Error('getClientConfig can only be called in the browser');
    }

    const config = window[PUBLIC_ENV_KEY] as unknown as ClientConfigType;

    if (config == null) {
        throw new Error(`Client config not found on window.${PUBLIC_ENV_KEY}`);
    }

    return config;
}